import { Component } from "@angular/core";
import { ConfigureService } from "service/ng4-configure/ng4-configure.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  supportEmail;

  constructor(private configService: ConfigureService) {
    this.supportEmail = this.configService.config.supportEmail;
  }
}
